import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Consolidated funnel: this page now lives at /quick-quote-part-1/, which
// shows the Norwood picker inline when no class was chosen upstream. Keep
// this route as a permanent redirect so existing ads and links keep working.
// Send one 301 to the final URL with the trailing slash. The old 307 to
// /quick-quote-part-1 made a second hop to add the slash.
export const Route = createFileRoute("/quick-quote-norwood-page-1")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: withQuery("/quick-quote-part-1/", location.searchStr),
      statusCode: 301,
      replace: true,
    });
  },
  head: () => ({
    meta: [
      { title: "Get a Quick Quote - RESTORE Hair" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => null,
});
